import axios from '@/utils/request'

const ApiUrl = '/admin_api/v1/guide'
export function getList(params) {
  return axios.get(`${ApiUrl}/list/`, {
    params
  })
}

export function del(guide_id) {
  return axios.delete(`${ApiUrl}/${guide_id}/`)
}

export function getDetail(guide_id) {
  return axios.get(`${ApiUrl}/${guide_id}/detail/`)
}

export function add(data) {
  return axios.post(`${ApiUrl}/add/`, data)
}

export function edit(guide_id, data) {
  return axios.put(`${ApiUrl}/${guide_id}/`, data)
}

export function review(guide_id, data) {
  return axios.post(`${ApiUrl}/${guide_id}/review/`, data)
}
